import React from 'react';
import Label from 'components/form/Label/Label';
import classnames from 'classnames';

const ResponsiveLabel = props => (
  <>
    <Label
      {...props}
      className={classnames('mobileHide', props.className)}
      type={props.desktoptype}
    >
      {props.children}
    </Label>
    <Label
      {...props}
      className={classnames('desktopHide', props.className)}
      type={props.mobiletype}
    >
      {props.children}
    </Label>
  </>
);

export default ResponsiveLabel;
